var r="2%";export{r as ROW_SELECT_COLUMN_WIDTH};
//# sourceMappingURL=Table.constants.js.map
